import cognitoAuthenticationConfig from './cognitoAuthenticationConfig.json';

// Function to get config based on hostname - makes it testable
function getCognitoConfig() {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
    const port = typeof window !== 'undefined' ? window.location.port : '4321';
    const hostKey = port ? `${hostname}:${port}` : hostname;

    const config = cognitoAuthenticationConfig[hostKey as keyof typeof cognitoAuthenticationConfig] || 
                   cognitoAuthenticationConfig[hostname as keyof typeof cognitoAuthenticationConfig] ||
                   cognitoAuthenticationConfig['localhost:4321'];

    return config;
}

// Function to check if config is valid
function getIsValidConfig(config: any) {
    return config && 
           config.USER_POOL_ID && 
           !config.USER_POOL_ID.includes('{{');
}

// Function to get amplify config
function getAmplifyAuthConfig(config: any, isValid: boolean) {
    if (!isValid || typeof window === 'undefined') {
        return null;
    }

    const hostname = window.location.hostname;
    return {
        region: config.USER_POOL_REGION,
        userPoolId: config.USER_POOL_ID,
        userPoolWebClientId: config.USER_POOL_APP,
        identityPoolId: config.IDENTITY_POOL_ID,
        mandatorySignIn: true,
        oauth: {
            domain: config.USER_POOL_DOMAIN,
            scope: ['email', 'openid', 'profile'],
            redirectSignIn: window.location.protocol + '//' + window.location.host,
            redirectSignOut: window.location.protocol + '//' + window.location.host,
            responseType: 'code',
            options: {
                AdvancedSecurityDataCollectionFlag: false
            }
        },
        cookieStorage: {
            domain: hostname,
            path: '/',
            expires: 365,
            secure: config.COOKIES_SECURE_FLAG,
            sameSite: config.COOKIES_SAME_SITE_PROPERTY
        }
    };
}

// Initialize the exports
export const cognitoConfig = getCognitoConfig();
export const isValidConfig = getIsValidConfig(cognitoConfig);
export const amplifyAuthConfig = getAmplifyAuthConfig(cognitoConfig, isValidConfig);
